import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import InventoryForm from "./-form";
import { Header } from "@/components/universal/header";

export const Route = createFileRoute(
  "/_private/_inventory-360/inventory/create",
)({
  component: InventoryCreatePage,
});

function InventoryCreatePage() {
  return (
    <div>
      <title>Add to Inventory - Legrande Health Portal</title>
      <Header
        crumbs={[
          { name: "Inventory", link: { to: "/inventory/lookup" } },
          { name: "Add to Inventory", link: { to: "/inventory/create" } },
        ]}
      />
      <Card>
        <CardHeader>
          <CardTitle>Add Product to Inventory</CardTitle>
          <CardDescription>
            Select a product to add to inventory.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <InventoryForm />
        </CardContent>
      </Card>
    </div>
  );
}
